import { useAPISettings } from "@src/data-hooks/general-settings/settings.service";
import { getPluralTenantUnitTitle } from "@src/utils/data/roles.utils";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { PropertyData } from "../../../to-be-removed/LocalData/Property/PropertyData";
import { UnitData } from "../../../to-be-removed/LocalData/Property/Units/UnitData";
import { LoadingIndicator } from "../../ui-components/LoadingIndicator/LoadingIndicator";
import { ModalPopup } from "../ModalPopup/ModalPopup";
import { TenantSelector } from "../TenantSelector/TenantSelector";

type Props = {
  id: string;
  onSelect: (units: UnitData[]) => void;
  property: PropertyData;
  title?: string;
  placeholder?: string;
  units?: UnitData[];
  defaultSelectedUnits?: UnitData[];
  disallowEmpty?: boolean;
};

export const UnitSelectPopup = (props: Props) => {
  const { settings } = useAPISettings();
  const [units, setUnits] = useState<UnitData[]>(props.defaultSelectedUnits ?? []);
  const [unitsLoaded, setUnitsLoaded] = useState(props.units || props.property.unitsLoaded);

  useEffect(() => {
    if (!unitsLoaded && !props.units) {
      props.property.loadUnits(() => {
        setTimeout(() => {
          setUnitsLoaded(true);
        }, 3000);
      });
    } else {
      setUnitsLoaded(true);
    }
  }, [props.property]);

  return (
    <ModalPopup
      id={props.id}
      title={props.title ?? t("main.selectTenants")}
      disableAction={props.disallowEmpty && units.length === 0}
      onActionClicked={() => props.onSelect(units)}
      children={
        unitsLoaded ? (
          <TenantSelector
            dataCy="tenant-selector"
            placeholder={props.placeholder ?? t("main.select") + " " + getPluralTenantUnitTitle(settings?.data)}
            properties={[props.property]}
            units={props.units ?? props.property.units}
            defaultSelected={props.defaultSelectedUnits}
            isMulti={true}
            changedSelectedTenants={(units) => setUnits(units)}
            width="100%"
            menuPortalTarget="popup"
          />
        ) : (
          <LoadingIndicator />
        )
      }
    />
  );
};

